import { Component, OnInit } from "@angular/core";
import { LookupService } from "../../services/technical-letters/lookup.service";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: "app-manage-issuers",
    templateUrl: "./manage-issuers.component.html",
    standalone: false
})
export class ManageIssuersComponent implements OnInit {
  isIssuersLoading: boolean = false;
  isAddingIssuer: boolean = false;
  addIssuerForm: FormGroup;
  validationErrors: string[] = [];

  issuers: any[] = [];

  constructor(
    private lookupService: LookupService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.addIssuerForm = this.formBuilder.group({
      issuerName: [""],
    });
    this.isIssuersLoading = true;
    this.lookupService.getLookups(3).subscribe({
      next: (data) => {
        this.issuers = data;
        this.isIssuersLoading = false;
      },
      error: (error) => {
        console.error("Error fetching issuers:", error);
        this.isIssuersLoading = false;
      },
    });
  }

  addNewIssuer() {
    this.validationErrors = [];
    this.isAddingIssuer = true;
    var issuerName = this.addIssuerForm.get("issuerName").value;
    if (issuerName.trim() === "") {
      this.validationErrors.push("Issuer name cannot be empty.");
      this.isAddingIssuer = false;
      return;
    }
    this.lookupService.addLookup(issuerName).subscribe({
      next: (data) => {
        this.issuers.push(data);
        this.addIssuerForm.reset();
      },
      error: (error) => {
        console.error("Error adding issuer:", error);
      },
    });
    this.isAddingIssuer = false;
  }
}
